import { renderSlot as _renderSlot, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createBlock($setup["DialogDescription"], _mergeProps({
        "data-slot": "sheet-description",
        class: $setup.cn('text-muted-foreground text-sm', $setup.props.class)
    }, $setup.delegatedProps), {
        default: _withCtx(() => [
            _renderSlot(_ctx.$slots, "default")
        ]),
        _: 3 /* FORWARDED */
    }, 16 /* FULL_PROPS */, ["class"]));
}
